module.exports = __webpack_public_path__ + "media/applicants/shopper2-feaae2ea.jpg";